<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'ROLES.ROLES_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddRole">
          <button mat-raised-button class="btn btn-primary" (click)="addRole()">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>Add Role</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportRolesAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="d-flex align-items-end justify-content-end">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            <strong>{{ 'TABLE.SEARCH' | translate }}</strong>
            {{ 'TABLE.IN_ALL_FIELDS' | translate }}
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          style="margin-bottom: 1.34375em"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
      <div class="collapse" [ngClass]="{ show: selection.selected.length > 0 }">
        <label>
          <span class="font-weight-bold">{{ 'GLOBAL.SELECTED_RECORDS_COUNT' | translate }}</span>
          {{ selection.selected.length }}
        </label>
        <div>
          <ng-template ngxPermissionsOnly="canSoftDeleteRole">
            <button mat-raised-button class="btn btn-danger" (click)="deleteRoles()">
              <mat-icon>delete</mat-icon>
              {{ 'TABLE.DELETE' | translate }}
            </button>
          </ng-template>
          <button mat-raised-button class="btn btn-light ml-2" (click)="fetchRoles()">
            <mat-icon>clear_all</mat-icon>
            {{ 'GLOBAL.FETCH_SELECTED' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="mat-column-checkbox">
            <mat-checkbox
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              (change)="$event ? masterToggle() : null"
            ></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="mat-column-checkbox">
            <mat-checkbox
              [checked]="selection.isSelected(row)"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
            ></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchSelect">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'ROLES.TABLE.TITLE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let role">{{ role.title }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="template">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'ROLES.TABLE.TEMPLATE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let role">{{ role.template }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchTitle">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'ROLES.TABLE.TITLE' | translate }}</mat-label>
              <input matInput #searchTitleInput [placeholder]="'ROLES.TABLE.TITLE' | translate" />
              <button
                *ngIf="searchTitleInput.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="resetInput($event, searchTitleInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="department">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Department</mat-header-cell>
          <mat-cell *matCellDef="let role">{{ role.department_name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDepartment">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Department</mat-label>
              <mat-select #searchDepartmentSelect [placeholder]="'Department'">
                <mat-option value=""></mat-option>
                <mat-option
                  *ngFor="let department of departments$ | async"
                  [value]="department.id"
                  >{{ department.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container *ngIf="isSuperAdmin" matColumnDef="company">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'ROLES.TABLE.COMPANY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let role">{{ getCompanyName(role.companyID) }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCompany">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchCompanyAutocomplete
              *ngIf="isSuperAdmin"
              [label]="'ROLES.TABLE.COMPANY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getCompanyAutocomplete"
              [optionFormatter]="formatCompanyOption"
              [valueFormatter]="formatCompanyOption"
              [control]="searchCompanyAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let role">
            <ng-template ngxPermissionsOnly="canEditRole">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Role"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editRole(role)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteRole">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Role"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteRole(role)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
